export default function TeamSection() {
  return (
    <section id="team" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-stone-900 mb-4">
            Professional Excellence
          </h2>
          <p className="text-stone-600 font-light max-w-2xl mx-auto">
            Dedicated to providing exceptional legal services with integrity and expertise
          </p>
        </div>
        
        <div className="max-w-2xl mx-auto">
          <div className="text-center bg-stone-50 p-12 rounded-lg">
            <div className="flex justify-center mb-8">
              <div className="w-40 h-40 rounded-full overflow-hidden border-2 border-stone-300 shadow-md">
                <img
                  src="https://static.readdy.ai/image/000745ea5477ac1971ad11ea6f2dc4d7/120a5dde0c51f00a4b1f16e4c0950351.jpeg"
                  alt="Paula Lopes - Legal Analyst/Lawyer"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            
            <h3 className="text-2xl font-light text-stone-900 mb-2">
              PAULA LOPES
            </h3>
            <p className="text-stone-600 font-light mb-6">
              Legal Analyst/Lawyer
            </p>
            
            <div className="space-y-4 text-stone-600 font-light">
              <p>
                Experienced legal professional specializing in corporate law, contract management, and legal consultation services.
              </p>
              <p>
                Committed to providing personalized legal solutions that protect your interests and support your business objectives.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8 pt-8 border-t border-stone-200">
              <div className="text-center">
                <div className="text-2xl font-light text-stone-800 mb-1">20+</div>
                <div className="text-sm text-stone-600">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-light text-stone-800 mb-1">500+</div>
                <div className="text-sm text-stone-600">Cases Handled</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-light text-stone-800 mb-1">95%</div>
                <div className="text-sm text-stone-600">Success Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
